import { render } from "./clickDrag.vue?vue&type=template&id=723cbb67&scoped=true"
import script from "./clickDrag.vue?vue&type=script&lang=js"
export * from "./clickDrag.vue?vue&type=script&lang=js"

import "./clickDrag.vue?vue&type=style&index=0&id=723cbb67&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723cbb67"]])

export default __exports__